import React from 'react';

import EcoClub8Class2025 from 'views/EcoClub8Class2025';

const AccountGeneralPage = () => {
  return <EcoClub8Class2025/>;
};

export default AccountGeneralPage;